@import (reference) '../../../constants/spacing.module.less';

.order-details-selected-content {
  flex: 1;
  display: flex;
  flex-flow: column nowrap;

  background: inherit;

  &.no-header-row {
    padding-top: @space-16;
  }
}
